module.exports = __webpack_public_path__ + "static/img/1_6_1.7c52a1ff.jpg";